import React from 'react'
import { experience, education } from '../../portfolio'
import ExperienceContainer from './Experience'
import EducationContainer from './Education'
import './Style.css'

const ExperienceAndEducation = () => (
  <div>
    <section id='experience' className='section'>
      <div className='experience__section'>
        <h2 className='section__subtitle def_marg'>Experience</h2>
        <div className='experience__grid'>
          {experience.map((exp) => (
            <ExperienceContainer experience={exp} key={exp.company} />
          ))}
        </div>
      </div>
    </section>
    <section id='education' className='section'>
      <div className='education__section'>
        <h2 className='section__subtitle def_marg'>Education</h2>
        <div className='education__grid'>
          {education.map((edu) => (
            <EducationContainer education={edu} key={edu.institution} />
          ))}
        </div>
      </div>
    </section>
  </div>
)

export default ExperienceAndEducation
